import { Action } from '@ngrx/store';
import { OrderULResponse, PatchOrderRequestedResponse } from '@cemex-core/cmx-api';
import { OrderUL } from '@cemex-core/cmx-api/models/order-management/order';

export enum RmsOrderActionTypes {
  REQUEST = '[Rms Order Open Platform] Request',
  REQUEST_COMPLETE = '[Rms Order Open Platform] Request complete',
  REQUEST_COMMAND = '[Command Order Open Platform] Request',
  REQUEST_COMMAND_COMPLETE = '[Command Order Open Platform] Request complete',
  RESET = '[Rms Order Open Platform] Reset',
}

export class RmsOrderLoadActionOP implements Action {
  readonly type = RmsOrderActionTypes.REQUEST;

  constructor() {}
}

export class RmsOrderLoadCompleteActionOP implements Action {
  readonly type = RmsOrderActionTypes.REQUEST_COMPLETE;

  constructor(public payload: OrderULResponse | OrderUL | PatchOrderRequestedResponse) {}
}

export class CommandOrderLoadActionOP implements Action {
  readonly type = RmsOrderActionTypes.REQUEST_COMMAND;

  constructor() {}
}

export class CommandOrderLoadCompleteActionOP implements Action {
  readonly type = RmsOrderActionTypes.REQUEST_COMMAND_COMPLETE;

  constructor(public payload: PatchOrderRequestedResponse) {}
}

export class RmsOrderResetActionOP implements Action {
  readonly type = RmsOrderActionTypes.RESET;

  constructor() {}
}

export type RmsOrderActions =
  | RmsOrderLoadActionOP
  | RmsOrderLoadCompleteActionOP
  | CommandOrderLoadActionOP
  | CommandOrderLoadCompleteActionOP
  | RmsOrderResetActionOP;
